<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T11:44:01+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe: "what our customers are saying"
@Last modified by:   tom
@Last modified time: 2018-01-24T10:42:33+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <section id="testimonial" class="bg-secondary">
    <div class="header">
      <icon name="bullhorn" scale="2"/>
      <h1 class="text-white">{{ $t('testimonial.title') }}</h1>
    </div>
    <b-container>

      <blockquote
        v-for="f in 4"
        :key = "f"
        class="mb-0 text-white"
        v-html="$t('testimonial.' + f )"/>

    </b-container>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

  @import "../../assets/style/theme.scss";

  #testimonial {
    color: $primaryWhite;
  }

</style>
